import React, { useState } from 'react';
import './Doacao.css';

const Doacao = ({ onContinue }) => {
  const [valorSelecionado, setValorSelecionado] = useState(null);
  const [valorCustom, setValorCustom] = useState('');
  const [loading, setLoading] = useState(false);
  const [pixData, setPixData] = useState(null);
  const [copiado, setCopiado] = useState(false);

  const valoresSugeridos = [5, 10, 15];

  const gerarTxId = () => {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let txid = '';
    for (let i = 0; i < 35; i++) {
      txid += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
    }
    return txid;
  };

  const handleDoar = async () => {
    const valor = valorSelecionado || parseFloat(valorCustom);
    
    if (!valor || valor <= 0) {
      alert('Por favor, selecione ou digite um valor válido para doação.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://api.pontobonus.com.br/api/assinatura/pix/pagamento', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          txid: gerarTxId(),
          valor: valor,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao gerar PIX');
      }

      const data = await response.json();
      setPixData(data);
    } catch (error) {
      console.error('Erro ao processar doação:', error);
      alert('Erro ao gerar código PIX. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const copiarCodigo = () => {
    if (pixData?.codigo_pix) {
      navigator.clipboard.writeText(pixData.codigo_pix);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    }
  };

  const handleValorSugerido = (valor) => {
    setValorSelecionado(valor);
    setValorCustom('');
  };

  const handleValorCustom = (e) => {
    const valor = e.target.value;
    setValorCustom(valor);
    setValorSelecionado(null);
  };

  return (
    <div className="doacao-container">
      <div className="doacao-card">
        <div className="doacao-header">
          <div className="doacao-icon">
            <svg 
              className="heart-icon" 
              fill="currentColor" 
              viewBox="0 0 24 24"
            >
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          </div>
          <h1 className="doacao-title">Apoie Este Projeto</h1>
          <p className="doacao-description">
            Este sistema de gerenciamento de eventos está em <span className="highlight">desenvolvimento</span> e 
            está com <span className="highlight-blue">uso livre</span> durante este processo.
          </p>
        </div>

        <div className="doacao-content">
          {!pixData ? (
            <>
              {/* Mensagem */}
              <div className="doacao-message">
                <p>
                  Contamos com suas doações para podermos aperfeiçoar o sistema! 
                  Se este sistema está te ajudando e você deseja contribuir para mantê-lo 
                  funcionando e em constante evolução, ficaremos muito gratos pela sua doação! ❤️
                </p>
              </div>

              {/* Valores sugeridos */}
              <div className="valores-section">
                <h3>Selecione um valor ou digite o quanto desejar:</h3>
                <div className="valores-grid">
                  {valoresSugeridos.map((valor) => (
                    <button
                      key={valor}
                      className={`valor-btn ${valorSelecionado === valor ? 'valor-btn-selected' : ''}`}
                      onClick={() => handleValorSugerido(valor)}
                    >
                      R$ {valor},00
                    </button>
                  ))}
                </div>
              </div>

              {/* Valor customizado */}
              <div className="custom-valor-section">
                <label>Ou digite outro valor:</label>
                <div className="custom-valor-input">
                  <span className="currency-symbol">R$</span>
                  <input
                    type="number"
                    min="1"
                    step="0.01"
                    placeholder="0,00"
                    value={valorCustom}
                    onChange={handleValorCustom}
                  />
                </div>
              </div>

              {/* Botões de ação */}
              <div className="doacao-actions">
                <button
                  onClick={handleDoar}
                  disabled={loading || (!valorSelecionado && !valorCustom)}
                  className="btn btn-doar"
                >
                  {loading ? (
                    <>
                      <span className="spinner-small"></span>
                      Gerando PIX...
                    </>
                  ) : (
                    <>
                      <svg className="heart-icon-small" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                      </svg>
                      Doar
                    </>
                  )}
                </button>
                <button
                  onClick={onContinue}
                  className="btn btn-skip"
                >
                  Pular e Continuar
                </button>
              </div>
            </>
          ) : (
            <>
              {/* QR Code e instruções */}
              <div className="pix-section">
                <div className="pix-success">
                  <h3>PIX Gerado com Sucesso! 🎉</h3>
                  <p>
                    Valor da doação: <span className="valor-destaque">
                      R$ {(valorSelecionado || parseFloat(valorCustom)).toFixed(2).replace('.', ',')}
                    </span>
                  </p>
                </div>

                <div className="pix-content-wrapper">
                  {/* QR Code */}
                  <div className="qr-code-section">
                    <div className="qr-code-container">
                      <img
                        src={pixData.qr_code}
                        alt="QR Code PIX"
                        className="qr-code-image"
                      />
                    </div>
                    <p className="qr-code-hint">
                      Escaneie o QR Code com o app do seu banco
                    </p>
                  </div>

                  {/* Instruções */}
                  <div className="instrucoes-section">
                    <div className="instrucoes-box">
                      <h4>Como pagar com PIX:</h4>
                      <ol>
                        <li>
                          <span className="step-number">1.</span>
                          Abra o aplicativo do seu banco
                        </li>
                        <li>
                          <span className="step-number">2.</span>
                          Escolha pagar com PIX
                        </li>
                        <li>
                          <span className="step-number">3.</span>
                          Escaneie o QR Code ou copie e cole o código
                        </li>
                        <li>
                          <span className="step-number">4.</span>
                          Confirme o pagamento
                        </li>
                      </ol>
                    </div>

                    {/* Código PIX */}
                    <div className="codigo-pix-section">
                      <label>Código PIX (Copia e Cola):</label>
                      <div className="codigo-pix-input">
                        <input
                          value={pixData.codigo_pix || pixData.codigo}
                          readOnly
                          className="codigo-input"
                        />
                        <button
                          onClick={copiarCodigo}
                          className="btn btn-copiar"
                        >
                          {copiado ? (
                            <>
                              <svg className="icon-check" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                              Copiado!
                            </>
                          ) : (
                            <>
                              <svg className="icon-copy" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                              Copiar
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Agradecimento */}
                <div className="agradecimento-box">
                  <p className="agradecimento-title">
                    Muito obrigado pelo seu apoio! ❤️
                  </p>
                  <p className="agradecimento-text">
                    Sua contribuição ajuda a manter este projeto vivo e em constante melhoria.
                  </p>
                </div>

                {/* Botão continuar */}
                <button
                  onClick={onContinue}
                  className="btn btn-continuar"
                >
                  Continuar para o Sistema
                </button>
              </div>
            </>
          )}

          {/* Garantia */}
          <div className="doacao-footer">
            <p>
              🔒 Pagamento seguro via PIX • Seus dados estão protegidos
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Doacao;
